export default "__VITE_ASSET__CkYuxz_e__"